export default __webpack_public_path__ + "static/media/s.0545b5f5.png";